import { c as _c } from "react/compiler-runtime";
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { ReactElement, forwardRef } from 'react';
import ChevronLeft from '@core/shared/ui/icons/ChevronLeft';
import ChevronRight from '@core/shared/ui/icons/ChevronRight';
interface NavButtonProps {
  variant: 'prev' | 'next';
  hovered?: boolean;
  disabled?: boolean;
}
export const NavButton = forwardRef<HTMLButtonElement, NavButtonProps>(function NavButton(t0, ref) {
  const $ = _c(20);
  const {
    variant,
    hovered: t1,
    disabled: t2
  } = t0;
  const hovered = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? true : t2;
  const theme = useTheme();
  const t3 = `${variant}-${!disabled ? "button" : "button-disabled"}`;
  const t4 = hovered && !disabled ? 1 : 0;
  let t5;
  if ($[0] !== t4) {
    t5 = {
      xs: 0,
      md: t4
    };
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = variant === "prev" ? 10 : undefined;
  const t7 = variant === "next" ? 10 : undefined;
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      xs: 0,
      md: 1
    };
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== theme.palette.background.paper) {
    t9 = {
      backgroundColor: theme.palette.background.paper,
      opacity: t8
    };
    $[3] = theme.palette.background.paper;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      display: "none"
    };
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  if ($[6] !== t5 || $[7] !== t6 || $[8] !== t7 || $[9] !== t9 || $[10] !== theme.palette.background.paper || $[11] !== theme.shadows[2]) {
    t11 = {
      zIndex: 2,
      cursor: "pointer",
      position: "absolute",
      boxShadow: theme.shadows[2],
      opacity: t5,
      left: t6,
      right: t7,
      top: "37%",
      transition: "opacity 0.2s ease-out",
      backgroundColor: theme.palette.background.paper,
      "&:hover": t9,
      "&.swiper-button-disabled": t10
    };
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t9;
    $[10] = theme.palette.background.paper;
    $[11] = theme.shadows[2];
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== variant) {
    t12 = variant === "prev" ? <ChevronLeft /> : <ChevronRight />;
    $[13] = variant;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== ref || $[16] !== t11 || $[17] !== t12 || $[18] !== t3) {
    t13 = <IconButton ref={ref} aria-label={t3} sx={t11}>{t12}</IconButton>;
    $[15] = ref;
    $[16] = t11;
    $[17] = t12;
    $[18] = t3;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  return t13;
});